/** 超限提示默认阈值：后端宽表查询单次最多返回 10000 条，超出则触发超限提示 */
export const DEFAULT_LIMIT_COUNT = 10000;
